import * as React from "react";
import { useMediaQuery, Theme, Chip } from "@mui/material";
import {
  SimpleList,
  EmailField,
  TextField,
  DateField,
  FunctionField,
  BooleanField,
  EditButton,
  TextInput,
  SelectInput
} from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";
import { StatusEnum } from "../../common/enum";
import { RoleEnum } from "src/common/enum/RoleEnum";

export const UserList = (props) => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />,
    <SelectInput source="roles.like" label="Roles" choices={RoleEnum} />,
    <SelectInput
      source="verified"
      choices={[
        {
          id: "true",
          name: "Verified",
        },
        {
          id: "false",
          name: "Unverified",
        },
      ]}
    />,
    <SelectInput
      source="confirmed"
      choices={[
        {
          id: "true",
          name: "Confirmed",
        },
        {
          id: "false",
          name: "Unconfirmed",
        },
      ]}
    />,
  ];

  return (
    <List filters={listFilters} {...props}>
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.name}
          secondaryText={(record) => record.username}
          tertiaryText={(record) => record.email}
        />
      ) : (
        <Datagrid>
          <TextField source="id" />
          <FunctionField
            label="Name"
            render={(record) => `${record.first_name} ${record.last_name}`}
          />
          <EmailField source="email" />

          <FunctionField
            label="Roles"
            render={(record) => {
              return (
                <div style={{ display: "flex", gap: 4 }}>
                  {[...record.customer_roles, ...record.admin_roles].map((roleId, index) => {
                    return (
                      <Chip
                      key={`${index}-${roleId}`}
                        label={RoleEnum.find((x) => x.id === roleId)?.name}
                      />
                    );
                  })}
                </div>
              );
            }}
          />
          <BooleanField source="verified" />
          <BooleanField source="confirmed" />
          <FunctionField
            label="Status"
            render={(record) =>
              StatusEnum.find((x) => x.id === record.status)?.name
            }
          />
          <DateField source="created_at" label="Created At" />
          <IfCanAccess action="edit">
            <EditButton />
          </IfCanAccess>
        </Datagrid>
      )}
    </List>
  );
};
